import styled from 'styled-components/macro';

export const PieChartContainer = styled.div`
  width: '100%';
`;
